import { paramsConfig, paramsMaxSizeSearch } from "../../utils/paramsUtils";
import axios from "axios";
import { ITableTimesheet } from "../models/timesheetModels";
import { localStorageItem } from "../../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";

const API_URL_CHAM_CONG = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["hrmTimekeeping"] || process.env.REACT_APP_API_URL_CHAM_CONG;

export const searchListTimesheet = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/general-timesheet/page`;
    return axios.get(url, paramsConfig(searchData))
};

export const searchTimeSheet = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong/page`;
    return axios.get(url, paramsConfig(searchData))
};

export const searchTimekeepingSynthetic = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/tong-hop-nhan-su`;
    return axios.get(url, paramsConfig(searchData))
}

export const searchListEmployeeSynthetic = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/tong-hop-nhan-su/danh-sach`;
    return axios.get(url, paramsConfig(searchData))
}

export const updateTimeSheet = (data: ITableTimesheet[]) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong`;
    return axios.put(url, data);
};

export const autoUpdateTimeSheet = (data: any) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong/update`;
    return axios.put(url, data);
}

export const approveTimeSheet = (id: string) => {
    let url = `${API_URL_CHAM_CONG}/general-timesheet/approve/${id}`;
    return axios.put(url);
}

export const searchListDayTruc = (searchObj: any) => {
    return axios.get(`${API_URL_CHAM_CONG}/day-truc/search`, paramsMaxSizeSearch(searchObj));
};

export const getDayTruc = (idDayTruc: string) => {
    return axios.get(`${API_URL_CHAM_CONG}/day-truc/${idDayTruc}`);
};

export const createDayTruc = (data: any) => {
    return axios.post(`${API_URL_CHAM_CONG}/day-truc`, data);
};

export const editDayTruc = (idDayTruc: string, data: any) => {
    return axios.put(`${API_URL_CHAM_CONG}/day-truc/${idDayTruc}`, data);
};

export const deleteDayTruc = (ids: string[]) => {
    return axios.delete(`${API_URL_CHAM_CONG}/day-truc/ids?ids=${ids.toString()}`);
};

export const searchTimeSheetOvertime = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong/them-gio`;
    return axios.get(url, paramsConfig(searchData))
};

export const searchListTimeSheetSchedule = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/general-timesheet/page`;
    return axios.get(url, paramsConfig(searchData))
};

export const searchTimeSheetSchedule = (searchData: any) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong-day-truc/page`;
    return axios.get(url, paramsConfig(searchData))
};

export const updateTimeSheetSchedule = (data: ITableTimesheet[]) => {
    let url = `${API_URL_CHAM_CONG}/bang-cham-cong-day-truc`;
    return axios.put(url, data);
};

export const autoUpdateTimeSheetSchedule = (data: any) => {
    return axios.put(`${API_URL_CHAM_CONG}/bang-cham-cong-day-truc/update`, data);
};